import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

export const PANCHANG_FAQS = [
  {
    question: "What is Panchang?",
    answer: "Panchang is the traditional Hindu calendar used to track astronomical daily data. It relies on the position of the Sun and Moon to calculate five essential elements: Tithi (lunar day), Vaara (weekday), Nakshatra (lunar mansion), Yoga, and Karana. It is widely used to find auspicious times (Muhurat) for religious ceremonies, travel, and business."
  },
  {
    question: "How to check today's Tithi?",
    answer: "You can check today's Tithi by looking at the 'Panchang Today' section above. Simply select today's date from the calendar to instantly view the current Tithi, its corresponding ruling deity, and exactly what time it ends. The Hindu Tithi Today is crucial for identifying dates for fasting (like Ekadashi or Purnima)."
  },
  {
    question: "What is Nakshatra in the Hindu Calendar?",
    answer: "A Nakshatra is a lunar mansion or sector along the ecliptic. There are 27 Nakshatras in Vedic astrology. The 'Nakshatra Today' refers to the specific constellation the Moon is transiting through on that given day. Nakshatras deeply influence a day's energy and the nature of tasks that will be successful during that period."
  },
  {
    question: "What is a Shubh Muhurat?",
    answer: "A Shubh Muhurat is an auspicious window of time in the daily Panchang during which planetary alignments are highly favorable. Starting a new business, buying a vehicle, or conducting a marriage during a Shubh Muhurat is believed to ensure success and prosperity while removing negative obstacles."
  },
  {
    question: "Is this Panchang accurate for Bareilly?",
    answer: "Yes, our online Panchang uses the specific geographical coordinates of Bareilly (Nath Nagri) to calculate exact Sunrise, Sunset, Moonrise, and planetary times. Since astronomical events vary depending on your latitude and longitude, a localized Hindu Calendar is much more accurate than a generic printed Panchang."
  }
];

const PanchangFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <div className="bg-white rounded-3xl border border-stone-150 p-8 md:p-12 shadow-sm my-12">
      <div className="mb-8 border-b border-stone-100 pb-6 text-center md:text-left">
        <h2 className="text-3xl font-extrabold text-stone-900 mb-2">Frequently Asked Questions (FAQ)</h2>
        <p className="text-stone-600 font-medium">Common questions regarding the Daily Panchang and Hindu Calendar calculations.</p>
      </div>

      <div className="space-y-4">
        {PANCHANG_FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return (
            <div 
              key={index} 
              className={`border rounded-2xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-saffron-300 bg-saffron-50/30' : 'border-stone-200 bg-stone-50 hover:bg-stone-100'}`}
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left focus:outline-none"
              >
                <h3 className="text-lg font-bold text-stone-900 pr-4">{faq.question}</h3>
                {isOpen ? (
                  <ChevronUp className="h-5 w-5 text-saffron-600 flex-shrink-0" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-stone-400 flex-shrink-0" />
                )}
              </button>
              
              <div 
                className={`px-5 md:px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'}`}
              >
                <p className="text-stone-700 leading-relaxed border-t border-saffron-200 pt-4">
                  {faq.answer}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PanchangFAQ;
